(() => {
  const ready = (callback) => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback, { once: true });
    else callback();
  };

  const setupHomepageMotion = () => {
    const motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    const homepage = document.querySelector('.template-index');
    if (!homepage) return;

    const videos = () => [...document.querySelectorAll('.template-index video[autoplay], .template-index video[data-motion-paused="true"]')];
    const observedVideos = new WeakSet();
    const observer = 'IntersectionObserver' in window
      ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (motionQuery.matches) {
            video.pause();
          } else if (entry.isIntersecting) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });
      }, { rootMargin: '160px 0px', threshold: 0.05 })
      : null;

    const registerVideo = (video) => {
      if (!(video instanceof HTMLVideoElement) || observedVideos.has(video)) return;
      observedVideos.add(video);
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;

      if (motionQuery.matches) {
        video.pause();
        video.removeAttribute('autoplay');
        video.dataset.motionPaused = 'true';
        return;
      }

      if (observer) observer.observe(video);
      else video.play().catch(() => {});
    };

    const registerVideos = (root = document) => {
      if (root instanceof HTMLVideoElement && root.autoplay) registerVideo(root);
      root.querySelectorAll?.('.template-index video[autoplay], video[autoplay]').forEach(registerVideo);
    };

    const applyPreference = () => {
      videos().forEach((video) => {
        if (motionQuery.matches) {
          video.pause();
          video.removeAttribute('autoplay');
          video.dataset.motionPaused = 'true';
        } else if (video.dataset.motionPaused === 'true') {
          video.setAttribute('autoplay', '');
          delete video.dataset.motionPaused;
          if (observer) observer.observe(video);
          else video.play().catch(() => {});
        }
      });
    };

    registerVideos();
    applyPreference();
    motionQuery.addEventListener?.('change', applyPreference);

    const mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) registerVideos(node);
        });
      });
    });
    mutationObserver.observe(document.body, { childList: true, subtree: true });
  };

  const setupCartAccessibility = () => {
    const cart = document.querySelector('section-cart');
    const drawer = cart?.querySelector('[data-cart]');
    if (!cart || !drawer) return;

    const triggers = [...document.querySelectorAll('[data-js-main-cart-btn]')];
    const updateState = () => {
      const isOpen = drawer.classList.contains('is-open');
      cart.setAttribute('aria-hidden', String(!isOpen));
      triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', String(isOpen)));
    };

    new MutationObserver(updateState).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    document.addEventListener('mini-cart:open', () => window.requestAnimationFrame(updateState));
    document.addEventListener('mini-cart:close', () => window.requestAnimationFrame(updateState));
    updateState();
  };

  const setupPromotionExpiry = () => {
    document.querySelectorAll('[data-promotion-ends-at]').forEach((promotion) => {
      const endsAt = Date.parse(promotion.dataset.promotionEndsAt || '');
      if (!Number.isFinite(endsAt)) {
        promotion.remove();
        return;
      }

      const removePromotion = () => promotion.remove();
      const remaining = endsAt - Date.now();
      if (remaining <= 0) removePromotion();
      else if (remaining <= 2147483647) window.setTimeout(removePromotion, remaining);
    });
  };

  ready(() => {
    setupHomepageMotion();
    setupCartAccessibility();
    setupPromotionExpiry();
  });
})();
